(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Draws the gold rule beside the steps as the page scrolls, and lights each step when
  // the rule reaches it. Without this file the list is the plain static one.
  const init = function (section) {
    if (section.dataset.howReady === 'true') return;
    const list = section.querySelector('.val-how__steps');
    const steps = list ? list.querySelectorAll('.val-how__step') : [];
    if (!steps.length) return;

    section.dataset.howReady = 'true';
    section.classList.add('val-how--scrub');

    let ticking = false;

    const update = function () {
      ticking = false;
      const view = window.innerHeight;
      const rect = list.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      const maxScroll = document.documentElement.scrollHeight - view;

      // Start when the list enters the lower part of the screen. This is the last
      // section on the page, so the end is capped at the furthest the page can scroll;
      // otherwise the rule could never finish.
      const start = top - view * 0.8;
      const end = Math.min(top + rect.height - view * 0.55, maxScroll - 1);
      const progress = end <= start ? 1 : Math.min(1, Math.max(0, (window.scrollY - start) / (end - start)));

      list.style.setProperty('--how-progress', progress.toFixed(3));

      const reached = progress * rect.height;
      steps.forEach(function (step) {
        step.classList.toggle('is-lit', reached >= step.offsetTop + 12);
      });
    };

    const request = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
    update();
  };

  document.querySelectorAll('.val-how').forEach(init);

  // Theme editor re-renders the section as a fresh node.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('.val-how').forEach(init);
    });
  }
})();
